import { render, staticRenderFns } from "./StateTributation.vue?vue&type=template&id=37809f39&"
import script from "./StateTributation.vue?vue&type=script&lang=js&"
export * from "./StateTributation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports